import React from 'react';
import { Flex } from 'pcln-design-system';
import styled, { keyframes } from 'styled-components';
const BaseSvg = ({
  children,
  ...props
}) => React.createElement("svg", {
  ...props
}, children);
const boxStretch = /*#__PURE__*/keyframes(["0%{width:0;stroke:#c28ce0;fill:#c28ce0;}50%{width:23px;stroke:#c28ce0;fill:#c28ce0;}100%{width:16.3809px;stroke:#7700BB;fill:none;}"]);
const boxShrink = /*#__PURE__*/keyframes(["0%{x:13px;width:16.3809px;}100%{x:15.3571;width:13.6508px;}"]);
const slideIn = /*#__PURE__*/keyframes(["0%{transform:translateY(5px);}50%{transform:translateY(2.5px);}100%{transform:none;}"]);
const fadeOut = /*#__PURE__*/keyframes(["0%{opacity:1;}100%{opacity:0;}"]);
const fadeIn = /*#__PURE__*/keyframes(["0%{opacity:0;}50%{opacity:0.75;}100%{opacity:1;}"]);
const shimmer = /*#__PURE__*/keyframes(["0%{opacity:0.5;}20%{opacity:0.75;}40%{opacity:0.5;}60%{opacity:0.75;}80%{opacity:0.5;}100%{opacity:1;}"]);
const animationTime = 500;
// icon is structured to show only fade-in/out animations for reduced-motion settings as they are considered safe for all users
// slide in/out animations are only shown for users who have no reduced-motion preferences
// 'no-preference' is the default setting for most users (users must explicitly opt-in to reduced motion on most devices)
const AnimatedIcon = /*#__PURE__*/styled.svg.withConfig({
  displayName: "AnimatedIcon",
  componentId: "sc-11gkik-0"
})([".icon_circle{opacity:0;&.top{animation:", "ms ease-out 0ms 1 forwards ", ",100ms linear ", "ms 1 forwards ", ";}&.middle{animation:", "ms ease-out ", "ms 1 forwards ", ",100ms linear ", "ms 1 forwards ", ";}&.bottom{animation:", "ms ease-out ", "ms 1 forwards ", ",100ms linear ", "ms 1 forwards ", ";}}.icon_box{x:15.3571px;width:13.6508px;&.top{animation:", "ms ease-out 0ms 1 forwards ", ";}&.middle{animation:", "ms ease-out ", "ms 1 forwards ", ";}&.bottom{animation:", "ms ease-out ", "ms 1 forwards ", ";}}path.icon_check{&.top{opacity:0;animation:", "ms ease-out ", "ms 1 forwards ", ";}&.middle{opacity:0;animation:", "ms ease-out ", "ms 1 forwards ", ";}&.bottom{opacity:0;animation:", "ms ease-out ", "ms 1 forwards ", ";}}path.icon_star{opacity:0;animation:", "ms ease-in-out ", "ms 1 forwards ", ";}@media (prefers-reduced-motion:no-preference){.icon_circle{opacity:0;&.top{animation:", "ms ease-out 0ms 1 forwards ", ",", "ms ease-out 0ms 1 forwards ", ",100ms linear ", "ms 1 forwards ", ";}&.middle{animation:", "ms ease-out ", "ms 1 forwards ", ",", "ms ease-out ", "ms 1 forwards ", ",100ms linear ", "ms 1 forwards ", ";}&.bottom{animation:", "ms ease-out ", "ms 1 forwards ", ",", "ms ease-out ", "ms 1 forwards ", ",100ms linear ", "ms 1 forwards ", ";}}.icon_box{x:13px;&.top{animation:", "ms ease-out 0ms 1 forwards ", ",", "ms ease-out ", "ms 1 forwards ", ";}&.middle{animation:", "ms ease-out ", "ms 1 forwards ", ",", "ms ease-out ", "ms 1 forwards ", ";}&.bottom{animation:", "ms ease-out ", "ms 1 forwards ", ",", "ms ease-out ", "ms 1 forwards ", ";}}path.icon_check{&.top{opacity:0;animation:", "ms ease-out ", "ms 1 forwards ", ",", "ms ease-out ", "ms 1 forwards ", ";}&.middle{opacity:0;animation:", "ms ease-out ", "ms 1 forwards ", ",", "ms ease-out ", "ms 1 forwards ", ";}&.bottom{opacity:0;animation:", "ms ease-out ", "ms 1 forwards ", ",", "ms ease-out ", "ms 1 forwards ", ";}}}"], animationTime, fadeIn, animationTime * 3, fadeOut, animationTime, animationTime, fadeIn, animationTime * 4, fadeOut, animationTime, animationTime * 2, fadeIn, animationTime * 5, fadeOut, animationTime, fadeIn, animationTime, animationTime, fadeIn, animationTime, animationTime * 2, fadeIn, animationTime, animationTime * 3, fadeIn, animationTime, animationTime * 4, fadeIn, animationTime, animationTime * 5, fadeIn, animationTime * 5, animationTime, shimmer, animationTime, slideIn, animationTime, fadeIn, animationTime * 3, fadeOut, animationTime, animationTime, slideIn, animationTime, animationTime, fadeIn, animationTime * 4, fadeOut, animationTime, animationTime * 2, slideIn, animationTime, animationTime * 2, fadeIn, animationTime * 5, fadeOut, animationTime, boxStretch, animationTime, animationTime * 3, boxShrink, animationTime, animationTime, boxStretch, animationTime, animationTime * 4, boxShrink, animationTime, animationTime * 2, boxStretch, animationTime, animationTime * 5, boxShrink, animationTime, animationTime * 3, slideIn, animationTime, animationTime * 3, fadeIn, animationTime, animationTime * 4, slideIn, animationTime, animationTime * 4, fadeIn, animationTime, animationTime * 5, slideIn, animationTime, animationTime * 5, fadeIn);
const BannerIcon = ({
  playAnimation
}) => {
  const SvgContainer = playAnimation ? AnimatedIcon : BaseSvg;
  return React.createElement(Flex, {
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: 'md',
    color: 'promoPrimary.light',
    height: '75px',
    width: '75px'
  }, React.createElement(SvgContainer, {
    alt: 'luggage icon',
    className: playAnimation ? 'icon_animate' : 'icon_blank',
    role: 'img',
    width: '55',
    height: '55',
    viewBox: '0 0 55 55',
    fill: 'none',
    xmlns: 'http://www.w3.org/2000/svg'
  }, React.createElement("g", {
    clipPath: 'url(#clip0_131_7877)'
  }, React.createElement("path", {
    className: 'icon_handle',
    fillRule: 'evenodd',
    clipRule: 'evenodd',
    d: 'M26.0865 0C26.7706 0 27.3251 0.554974 27.3251 1.23957C27.3251 1.8481 26.887 2.35421 26.3092 2.45917L26.0865 2.47914H25.0008V13.6354C25.0008 14.32 24.4463 14.875 23.7622 14.875C23.1542 14.875 22.6485 14.4365 22.5436 13.8583L22.5236 13.6354V2.47914H12.7151V13.6354C12.7151 14.32 12.1606 14.875 11.4765 14.875C10.8685 14.875 10.3628 14.4365 10.2579 13.8583L10.238 13.6354V2.47914H8.74639C8.06234 2.47914 7.50781 1.92417 7.50781 1.23957C7.50781 0.63104 7.94596 0.124928 8.52376 0.0199711L8.74639 0H26.0865ZM12.4621 51.873C12.4621 53.2422 11.3531 54.3521 9.98498 54.3521C8.61688 54.3521 7.50781 53.2422 7.50781 51.873H12.4621ZM25.0008 54.4141C26.3689 54.4141 27.478 53.2764 27.478 51.873H22.5236C22.5236 53.2764 23.6327 54.4141 25.0008 54.4141Z',
    fill: '#7700BB'
  }), React.createElement("path", {
    className: 'icon_body',
    d: 'M0 19.7228C0 15.6152 3.32719 12.2854 7.4315 12.2854H27.2488C31.3531 12.2854 34.6803 15.6152 34.6803 19.7228V44.5142C34.6803 48.6218 31.3531 51.9516 27.2488 51.9516H7.4315C3.32719 51.9516 0 48.6218 0 44.5142V19.7228Z',
    fill: 'white'
  }), React.createElement("rect", {
    className: 'icon_circle top',
    x: '5.40426',
    y: '20.0',
    width: '4.27179',
    height: '4.27574',
    rx: '2.1359',
    opacity: '0',
    stroke: '#7700BB',
    strokeWidth: '0.682538'
  }), React.createElement("rect", {
    className: 'icon_circle middle',
    x: '5.40426',
    y: '29.75',
    width: '4.09523',
    height: '4.09523',
    rx: '2.04761',
    opacity: '0',
    stroke: '#7700BB',
    strokeWidth: '0.682538'
  }), React.createElement("rect", {
    className: 'icon_circle bottom',
    x: '5.40426',
    y: '38.75',
    width: '4.09523',
    height: '4.09523',
    rx: '2.04761',
    opacity: '0',
    stroke: '#7700BB',
    strokeWidth: '0.682538'
  }), React.createElement("path", {
    className: 'icon_check top',
    opacity: '0',
    fillRule: 'evenodd',
    clipRule: 'evenodd',
    d: 'M8.15552 24.448C8.40148 24.4071 8.63747 24.2917 8.82721 24.1018L11.6601 21.2667C12.1437 20.7826 12.1437 19.9978 11.6601 19.5137C11.1764 19.0296 10.3921 19.0296 9.90843 19.5137L7.94436 21.4793L7.06874 20.603C6.58504 20.1189 5.80081 20.1189 5.31712 20.603C4.83342 21.0871 4.83342 21.872 5.31712 22.356L7.06356 24.1039C7.36061 24.4012 7.771 24.5159 8.15552 24.448Z',
    fill: '#7700BB'
  }), React.createElement("path", {
    className: 'icon_check middle',
    opacity: '0',
    fillRule: 'evenodd',
    clipRule: 'evenodd',
    d: 'M8.19827 34.6386C8.42874 34.5919 8.64849 34.4792 8.82721 34.3003L11.6601 31.4652C12.1437 30.9811 12.1437 30.1963 11.6601 29.7122C11.1764 29.2281 10.3921 29.2281 9.90843 29.7122L7.94414 31.678L7.06874 30.8019C6.58504 30.3179 5.80081 30.3179 5.31712 30.8019C4.83342 31.286 4.83342 32.0709 5.31712 32.555L7.06356 34.3028C7.37165 34.6111 7.80166 34.7231 8.19827 34.6386Z',
    fill: '#7700BB'
  }), React.createElement("path", {
    className: 'icon_check bottom',
    opacity: '0',
    fillRule: 'evenodd',
    clipRule: 'evenodd',
    d: 'M8.19694 44.1943C8.42789 44.1478 8.64814 44.0349 8.82721 43.8557L11.6601 41.0206C12.1437 40.5365 12.1437 39.7517 11.6601 39.2676C11.1764 38.7835 10.3921 38.7835 9.90843 39.2676L7.94415 41.2335L7.06874 40.3573C6.58504 39.8733 5.80081 39.8733 5.31712 40.3573C4.83342 40.8414 4.83342 41.6263 5.31712 42.1104L7.06356 43.8582C7.3713 44.1662 7.80069 44.2782 8.19694 44.1943Z',
    fill: '#7700BB'
  }), React.createElement("path", {
    className: 'icon_body',
    fillRule: 'evenodd',
    clipRule: 'evenodd',
    d: 'M27.2488 14.7645H7.4315C4.69529 14.7645 2.47717 16.9844 2.47717 19.7228V44.5142C2.47717 47.2526 4.69529 49.4725 7.4315 49.4725H27.2488C29.985 49.4725 32.2031 47.2526 32.2031 44.5142V19.7228C32.2031 16.9844 29.985 14.7645 27.2488 14.7645ZM7.4315 12.2854C3.32719 12.2854 0 15.6152 0 19.7228V44.5142C0 48.6218 3.32719 51.9516 7.4315 51.9516H27.2488C31.3531 51.9516 34.6803 48.6218 34.6803 44.5142V19.7228C34.6803 15.6152 31.3531 12.2854 27.2488 12.2854H7.4315Z',
    fill: '#7700BB'
  }), React.createElement("rect", {
    className: 'icon_box top shrink',
    x: '15.3571',
    y: '20.0',
    height: '4',
    width: '0',
    rx: '2.04761',
    stroke: '#7700BB',
    strokeWidth: '0.682538'
  }), React.createElement("rect", {
    className: 'icon_box middle shrink',
    x: '15.3571',
    y: '29.75',
    height: '4',
    width: '0',
    rx: '2.04761',
    stroke: '#7700BB',
    strokeWidth: '0.682538'
  }), React.createElement("rect", {
    className: 'icon_box bottom shrink',
    x: '15.3571',
    y: '38.75',
    height: '4',
    width: '0',
    rx: '2.04761',
    stroke: '#7700BB',
    strokeWidth: '0.682538'
  }), React.createElement("path", {
    className: 'icon_star',
    opacity: '0',
    d: 'M51.5649 7.7222C45.4462 7.17719 44.9903 6.73897 44.4262 0.824951C43.8614 6.73897 43.405 7.17739 37.2837 7.7222C43.405 8.2644 43.8614 8.70864 44.4262 14.6198C44.9903 8.70864 45.4462 8.2644 51.5649 7.7222Z',
    fill: '#7700BB'
  }), React.createElement("path", {
    className: 'icon_star',
    opacity: '0',
    d: 'M41.9025 13.7099C41.6869 15.9616 41.5124 16.1298 39.1821 16.338C41.5124 16.5429 41.6869 16.7152 41.9025 18.9691C42.1143 16.715 42.2888 16.5429 44.622 16.338C42.2888 16.1298 42.1143 15.9616 41.9025 13.7099Z',
    fill: '#7700BB'
  }), React.createElement("path", {
    className: 'icon_star',
    opacity: '0',
    d: 'M52.1289 11.1217C50.6138 11.2598 50.5002 11.3676 50.3598 12.8308C50.2206 11.3676 50.1066 11.2598 48.5915 11.1217C50.1066 10.9872 50.2206 10.8798 50.3598 9.41625C50.5002 10.8798 50.614 10.9872 52.1289 11.1217Z',
    fill: '#7700BB'
  })), React.createElement("defs", null, React.createElement("clipPath", {
    id: 'clip0_131_7877'
  }, React.createElement("rect", {
    width: '54.603',
    height: '54.603',
    fill: 'white'
  })))));
};
export default BannerIcon;